import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { Wrapper } from './styles'
import bungalowsIcon from 'assets/icons/bungalows.svg'
import Link from 'components/shared/Link'
import { FormattedMessage } from 'react-intl'

interface BungalowWrapperProps {
    index: number
    children: JSX.Element | JSX.Element[]
    isDeleteVisible?: boolean
    handleDelete?: () => void
}

const BungalowWrapper = ({
    index,
    children,
    isDeleteVisible = false,
    handleDelete,
}: BungalowWrapperProps) => (
    <Wrapper
        pt={[24, 32]}
        pb={[24, 40]}
        pl={[16, 32]}
        pr={[16, 32]}
        gap={[16, 24]}
        isFullWidth
    >
        <Box direction="row" justify="space-between" align="center" isFullWidth>
            <Box direction="row" justify="center" align="center" gap={16}>
                <img src={bungalowsIcon} alt="bungalows Icon" />
                <Text variant="heading4">
                    Bungalow{' '}
                    <Text as="span" variant="heading4" color="primary_500">
                        nr {index + 1}
                    </Text>
                </Text>
            </Box>
            {isDeleteVisible && (
                <Link
                    variant="secondary"
                    icon="bin"
                    onClick={handleDelete}
                    data-testid={`accommo-${index}-delete`}
                >
                    <FormattedMessage
                        id="global.btn.remove"
                        defaultMessage="Usuń"
                    />
                </Link>
            )}
        </Box>
        {children}
    </Wrapper>
)

export default BungalowWrapper
